// @flow

import { ActionsObservable } from 'redux-observable';
import moment from 'moment';
import 'rxjs/add/operator/map';
import { activate } from 'modules/rootEpic';
import { list as getEvents } from 'modules/event/rest';

import {
  ON_MOUNT,
  fetchRecentEvent, FETCH_RECENT_EVENT,
  fetchRecentEventDone,
} from './duck';

export const onMountEpic = (actions$: ActionsObservable) => actions$.ofType(ON_MOUNT)
  .map(fetchRecentEvent);

export const fetchRecentEventEpic = (actions$: ActionsObservable) => actions$.ofType(FETCH_RECENT_EVENT)
  .mergeMap(() => getEvents({
    before: moment.utc().format(),
    offset: 1,
    limit: 10,
  }, response => fetchRecentEventDone(response.items)));

activate(onMountEpic);
activate(fetchRecentEventEpic);
